<template>
  <div class="people-box">
    <div v-if="!curDetail.qyzwmc" class="rows">
        <p v-for="(item, index) in peopleData" class="row" :key="index" @click="goDetail(item)">
            <span class="img-box">
                <img :src="item.logoPath" alt="img" />
            </span>
            <span class="name">
                {{item.qyzwmc}}
            </span>
        </p>
    </div>
    <div v-else class="detail">
        <p class="title">{{curDetail.qyzwmc}}</p>
        <p class="sub-title">{{curDetail.ywmc}}</p>
        <img v-if="curDetail.gstpPath" class="img" :src="curDetail.gstpPath" alt="img" />
        <div v-html="curDetail.graphic"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      peopleData: [],
      curDetail: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getPeopleList()
    },
    // 回到列表
    goList () {
      this.curDetail = {}
    },
    async getPeopleList () {
      const res = await this.$https.getCyjgList({ page: 1, limit: 200 })
      this.peopleData = res.data.data.list
    },
    goDetail (item) {
      this.curDetail = item
    }
  }
}
</script>

<style scoped lang="less">
.people-box{
    display: flex;
    flex-direction: column;

    .rows{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .row{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 256px;
            height: 120px;
            border: 1px solid #f4f4f4;
            margin-bottom: 0px;
            cursor: pointer;

            &:hover{
                border: 1px solid #006ED1;
                color:#006ED1;
            }
        }
    }
}
.detail{
    display: flex;
    flex-direction: column;

    .title{
        font-size: 20px;
        color: #006ED1;
        width: 100%;
        text-align: center;
        margin: 0px;
        margin-top: 40px;
    }

    .sub-title{
        font-size: 18px;
        color: #333;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 40px;
    }
    .img{
        max-width: 100%;
    }
}
</style>
